class MicroChartModalCtrl {
  title;

  constructor(
    private microChartData,
    private offer,
    private targetMarketShare,
    private marketShare,
    private download
  ) {
    'ngInject';

    this.title = 'Pricing Offer of ' + offer.seller.name;
  }
}

export class MicroChartWithTiersModalService {
  constructor(private $bsModal: any, private $q: any) {
    'ngInject';
  }

  /**
   * Open the MicroChart Modal
   *
   * @param {any} microChartData The microchart data to display in the modal
   * @param {[type]} offer             [description]
   * @param {[type]} targetMarketShare [description]
   * @param {[type]} marketShare       [description]
   * @param {string} download          Download link if provided
   */
  openModal(
    microChartData,
    offer,
    targetMarketShare?,
    marketShare?,
    download?
  ) {
    const modalPromise = this.$q.defer();

    // TODO: Can we get UX to name this modal title something better?
    this.$bsModal({
      // title: 'Pricing Offer of ' + sellerName,
      template: `<div class="modal microChartModal" tabindex="-1" >
                  <div class="modal-dialog">
                    <div class="modal-content">
                      <div class="modal-header" ng-show="$ctrl.title">
                        <button type="button" class="close" ng-click="$hide()" aria-label="close" data-test-selector="x-modal-button">
                          <i class="fa fa-times"></i>
                        </button>
                        <h3 class="modal-title" ng-bind-html="$ctrl.title"></h3>
                      </div>
                      <div class="modal-body">
                        <div class="modal-inner-content">
                          <div class="lighter bigchartLegend">
                            <table style="margin-left: 110px; width: 459px;">
                              <tr>
                                <td>
                                  <div class="fl" style="height: 12px; width: 12px; margin-right: 6px;">
                                    <div style="height: 6px; width: 12px; background-color: #c77329"></div>
                                    <div style="height: 6px; width: 12px; background-color: #8ac342"></div>
                                  </div>
                                  Savings Range
                                </td>
                                <td>
                                  <img src="/aptitude/images/bestPriceMarker16x16.png" align="left"  style="margin-right: 6px" />
                                  Best Pricing Offer
                                </td>
                                <td class="plannedMarketShareLabel">
                                  <div class="fl" style="height: 12px; width: 3px; background-color: #4ac6eb; margin-right: 6px"></div>
                                  Planned Market Share
                                </td>
                              </tr>
                            </table>
                          </div>

                          <micro-chart-with-tiers micro-chart-data="$ctrl.microChartData" icon-data="$ctrl.offer"
                                                  target-market-share="$ctrl.targetMarketShare"
                                                  market-share="$ctrl.marketShare" size="'modal'"></micro-chart-with-tiers>

                        </div>
                      </div>
                      <div class="modal-footer">
                        <a
                          class="btn btn-default"
                          ng-href="{{ $ctrl.download }}"
                          ng-if="$ctrl.download"
                          data-test-selector="price-offer-download">
                            <i class="fa fa-lg fa-download"></i> Download
                        </a>
                        <button type="button" class="btn btn-primary"
                                ng-click="$hide()"
                                ng-disabled="$ctrl.submitDisabled"
                                data-test-selector="close-modal-button">Close</button>
                      </div>
                    </div>
                  </div>
                </div>`,
      controller: MicroChartModalCtrl,
      controllerAs: '$ctrl',
      backdrop: 'static',
      placement: 'center',
      dismissable: true,
      locals: {
        modalPromise: modalPromise,
        microChartData: microChartData,
        // sellerName: sellerName, // can we get this from the offer?
        offer: offer,
        targetMarketShare: targetMarketShare,
        marketShare: marketShare,
        download: download
      }
    });

    return modalPromise.promise;
  }
}
